import { makeFrame } from '@payaca/helpers/solarFacePacker';
import { type SolarLatLngLiteral } from './panelGeometry';
import { isConvexPolygonWithinRing } from '@payaca/helpers/solarConvexFootprint';

/**
 * Whether a whole convex panel lies within a simple roof outer ring.
 * Boundary contact is allowed; holes and setbacks are not considered.
 * Rings must be ordered, may use either winding and may be explicitly closed.
 * Empty, non-finite or degenerate geometry returns false. No input is mutated.
 */
export const isPanelWithinRoof = (
  panelCorners: ReadonlyArray<SolarLatLngLiteral>,
  roofOuter: ReadonlyArray<SolarLatLngLiteral>
): boolean => {
  if (
    panelCorners.length < 3 ||
    roofOuter.length < 3 ||
    ![...panelCorners, ...roofOuter].every(
      (p) => Number.isFinite(p.lat) && Number.isFinite(p.lng)
    )
  )
    return false;

  const frame = makeFrame(roofOuter[0]);
  return isConvexPolygonWithinRing(
    panelCorners.map(frame.toM),
    roofOuter.map(frame.toM)
  );
};
